// URLs de la API y recursos
export const API_URL = import.meta.env.VITE_API_URL || 'https://tambienacepto.com';
export const BASE_URL = 'https://tambienacepto.com';

// Información de contacto
export const CONTACT_INFO = {
  phones: ['+549 381 5615474'],
  email: 'm.team@tambienacepto.com',
  whatsapp: {
    number: '5493815615474',
    defaultMessage: '¡Hola! Quisiera información acerca de las tarjetas'
  }
};

// Redes sociales
export const SOCIAL_MEDIA = {
  instagram: 'https://www.instagram.com/tambienacepto'
};

// Google Tag Manager
export const GTM_ID = 'GTM-MWZWKDN9';
